import { View } from "binder"
import { ToolReplacement, ToolReplacementManipulationViewModel } from "./toolReplacementManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolReplacementManipulationView extends View<ToolReplacementManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-5155E655-D0E5-4E20-A2D1-0CB47F083D66"
    }
    loadHtml(): string {
        let element = require('./toolReplacementManipulation.html').default;
        let style = require('./toolReplacementManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolReplacements(v: ToolReplacement) { this._toolReplacements = v; } public get toolReplacements(): ToolReplacement { return this._toolReplacements; } private _toolReplacements: ToolReplacement;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;
}
